import './App.css';
import supabase from './supabaseClient';
import React, { useState } from "react";

// var selectedCategory = 'NA'
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function Register() { 

  // get service domain url from env variable named KC_service and use in api calls as needed
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; 

  // Add state for all fields
  const [username, setUsername] = useState('');
  const [emailid, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mobile, setMobile] = useState('');
  const [referredby, setReferredby] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage('');

    // Check if email or mobile already exists
    const { data, error } = await supabase
      .from('Users')
      .select('userid')
      .or(`emailid.eq.${emailid},mobile.eq.${mobile}`);

    if (error) {
      setMessage('Error checking user: ' + error.message);
      return;
    }

    if (data && data.length > 0) {
      setMessage('Email or Mobile number already registered.');
      return;
    }
    else {
      // Prepare user data - get user ID for referredby if provided
      let referredUserId = null;
      if (referredby) {
        const { data: refData, error: refError } = await supabase
          .from('Users')
          .select('userid')
          .eq('referralcode', referredby)
          .single();

        if (refError) {
          setMessage('Invalid referral code.');
          return;
        }
        referredUserId = refData ? refData.userid : null;
      }

      // insert new user record in database
      const { error: insertError } = await supabase
        .from('Users')
        .insert([{ username: username, emailid: emailid, password: password, mobile: mobile, referredby: referredUserId }]);

      if (insertError) {
        setMessage('Error registering user: ' + insertError.message);
        return;
      }

      // Redirect to profile page (adjust path as needed)
      window.location.href = '?pageName=Profile';
    }

    // Registration logic here (not implemented)
    setMessage('Registration successful (demo, not implemented).');
  };

 

  // OTP states
  const [emailConfirmed, setEmailConfirmed] = useState(false);
  const [mobileConfirmed, setMobileConfirmed] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [mobileOtpSent, setMobileOtpSent] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [mobileOtp, setMobileOtp] = useState('');
  const [enteredEmailOtp, setEnteredEmailOtp] = useState('');
  const [enteredMobileOtp, setEnteredMobileOtp] = useState('');
  const [emailOtpStatus, setEmailOtpStatus] = useState(null); // 'success' | 'fail' | null
  const [mobileOtpStatus, setMobileOtpStatus] = useState(null);

  // Helper to generate 6-digit OTP
  function generateOtp() {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  // Simulate sending OTP to email (replace with real API)
  const handleSendEmailOtp = async () => {
    const otp = generateOtp();
    setEmailOtp(otp);
    setEmailOtpSent(true);
    setEmailOtpStatus(null);
    //alert('OTP sent to email (1: ' + otp + ')');

      try {
        // Call your backend service API instead of database function
        const response = await fetch(KC_SERVICE + '/send-otp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            to: emailid,
            otp: otp,
            subject: "OTP for registering to Knowledgecheck.in",
            body: `OTP for registering to Knowledgecheck.in: ${otp}`
          })
        });

        setEmailOtpStatus(null); // Hide progress bar

        const result = await response.json();
        if (response.ok) {
          setMessage('OTP sent successfully to email.');
          setEmailOtpStatus(true);
        }
        else if (result.error) {
          setMessage('Failed to send OTP email: ' + (result.error || response.statusText));
          setEmailOtpStatus(false);
        }
      } catch (err) {
        setMessage('Error sending OTP email: ' + err.message);
      }
  };

  // Simulate sending OTP to mobile (replace with real API)
  const handleSendMobileOtp = async () => {
    const otp = generateOtp();
    setMobileOtp(otp);
    setMobileOtpSent(true);
    setMobileOtpStatus(null);
    setMessage('OTP sent to mobile (demo: ' + otp + ')');
    // TODO: Replace with actual SMS sending logic
    // Example: Use an API like Twilio, Nexmo, or a backend endpoint to send SMS.
    // Example with fetch to your backend:
    /*
    await fetch('/api/send-sms', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mobile, otp })
    });
    */
  };

  // Confirm entered email OTP
  const handleConfirmEmailOtp = () => {
    if (enteredEmailOtp === emailOtp && emailOtp) {
      setEmailConfirmed(true);
      setEmailOtpStatus('success');
      setMessage('');
    } else {
      setEmailOtpStatus('fail');
      setMessage('Invalid email OTP.');
    }
  };

  // Confirm entered mobile OTP
  const handleConfirmMobileOtp = () => {
    if (enteredMobileOtp === mobileOtp && mobileOtp) {
      setMobileConfirmed(true);
      setMobileOtpStatus('success');
      setMessage('');
    } else {
      setMobileOtpStatus('fail');
      setMessage('Invalid mobile OTP.');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '80vh', justifyContent: 'center' }}>
      <form
        onSubmit={handleRegister}
        style={{
          padding: '24px 32px',
          fontFamily: 'Arial, sans-serif',
          fontSize: '1.1em',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          minWidth: '350px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '18px' }}>User Registration</h2>
        {message && (
          <div style={{ marginBottom: '10px', color: emailOtpStatus === 'fail' || mobileOtpStatus === 'fail' ? 'red' : 'green', textAlign: 'center' }}>{message}</div>
        )}
        <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <label htmlFor="username" style={{ display: 'block', marginBottom: '4px', width: '100%', textAlign: 'center' }}>Name (will be seen by other users):</label>
          <input
            type="text"
            id="username"
            name="username"
            required
            style={{ width: '80%', padding: '6px' }}
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
        </div>
        {/* Email with OTP confirmation */}
        <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '4px', width: '100%', textAlign: 'center' }}>Email ID:</label>
            <div style={{ display: 'flex', width: '80%', alignItems: 'center' }}>
              <input
                type="email"
                id="emailid"
                name="emailid"
                required
                style={{ flex: 1, padding: '6px' }}
                value={emailid}
                onChange={e => {
            setEmail(e.target.value);
            setEmailConfirmed(false);
            setEmailOtpSent(false);
            setEmailOtp('');
            setEnteredEmailOtp('');
            setEmailOtpStatus(null);
                }}
                disabled={emailConfirmed}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                title="Please enter a valid email address"
              />
              {!emailConfirmed && (
                <button
            type="button"
            style={{ marginLeft: '8px', padding: '4px 10px' }}
            onClick={handleSendEmailOtp}
            disabled={
              !emailid ||
              emailOtpSent ||
              !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailid)
            }
                >
            {emailOtpSent ? 'Sent' : 'Confirm'}
                </button>
              )}
              {emailConfirmed && (
                <span style={{ marginLeft: '8px', color: 'green', fontSize: '1.5em' }}>✔️</span>
              )}
              {emailOtpStatus === 'fail' && (
                <span style={{ marginLeft: '8px', color: 'red', fontSize: '1.5em' }}>❌</span>
              )}
            </div>
            {/* OTP input for email */}
          {emailOtpSent && !emailConfirmed && (
            <div style={{ marginTop: '6px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <input
                type="text"
                placeholder="Enter OTP"
                value={enteredEmailOtp}
                onChange={e => setEnteredEmailOtp(e.target.value)}
                style={{ width: '60%', padding: '6px' }}
                maxLength={6}
              />
              <button
                type="button"
                style={{ marginLeft: '8px', padding: '4px 10px' }}
                onClick={handleConfirmEmailOtp}
                disabled={!enteredEmailOtp}
              >
                Verify
              </button>
            </div>
          )}
        </div>
        <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <label htmlFor="password" style={{ display: 'block', marginBottom: '4px', width: '100%', textAlign: 'center' }}>Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            required
            style={{ width: '80%', padding: '6px' }}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        {/* Mobile with OTP confirmation */}
          <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <label htmlFor="mobile" style={{ display: 'block', marginBottom: '4px', width: '100%', textAlign: 'center' }}>Mobile Number (optional):</label>
            <div style={{ display: 'flex', width: '80%', alignItems: 'center' }}>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                required
                style={{ flex: 1, padding: '6px' }}
                value={mobile}
                onChange={e => {
                  // Only allow digits and + sign
                  let val = e.target.value;
                  // Allow '+' only as the first character, rest must be digits
                    // Only allow numeric characters, no '+', and limit to 10 digits
                    val = val.replace(/\D/g, '').slice(0, 10);
                  setMobile(val);
                  setMobileConfirmed(false);
                  setMobileOtpSent(false);
                  setMobileOtp('');
                  setEnteredMobileOtp('');
                  setMobileOtpStatus(null);
                }}
                disabled={mobileConfirmed}
                pattern="^\+?\d{10,15}$"
                title="Enter a valid mobile number (digits and optional + sign)"
                inputMode="tel"
              />
              {!mobileConfirmed && (
                <button
            type="button"
            style={{ marginLeft: '8px', padding: '4px 10px' }}
            onClick={handleSendMobileOtp}
            disabled={!mobile || mobileOtpSent}
                >
            {mobileOtpSent ? 'Sent' : 'Confirm'}
                </button>
              )}
              {mobileConfirmed && (
                <span style={{ marginLeft: '8px', color: 'green', fontSize: '1.5em' }}>✔️</span>
              )}
              {mobileOtpStatus === 'fail' && (
                <span style={{ marginLeft: '8px', color: 'red', fontSize: '1.5em' }}>❌</span>
              )}
            </div>
            {/* OTP input for mobile */}
          {mobileOtpSent && !mobileConfirmed && (
            <div style={{ marginTop: '6px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <input
                type="text"
                placeholder="Enter OTP"
                value={enteredMobileOtp}
                onChange={e => setEnteredMobileOtp(e.target.value)}
                style={{ width: '60%', padding: '6px' }}
                maxLength={6}
              />
              <button
                type="button"
                style={{ marginLeft: '8px', padding: '4px 10px' }}
                onClick={handleConfirmMobileOtp}
                disabled={!enteredMobileOtp}
              >
                Verify
              </button>
            </div>
          )}
        </div>
        <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <label htmlFor="referral" style={{ display: 'block', marginBottom: '4px', width: '100%', textAlign: 'center' }}>Referral Code (optional):</label>
          <input
            type="text"
            id="referredby"
            name="referredby"
            style={{ width: '80%', padding: '6px' }}
            value={referredby}
            onChange={e => setReferredby(e.target.value)}
          />
        </div>
        <button
          type="submit"
          style={{ padding: '8px 16px', marginTop: '8px' }}
          disabled={!emailConfirmed}
        >
          Register
        </button>
      </form>
    </div>
  );
}

export default Register;